export default class HomeService {

    constructor(resource) {
        this._resource = resource('client/');
        this.about = resource('block/home')
        this.clippingResource = resource('clipping/');
        this.testimonialResource = resource('testimonial/');
        this.carouselResource = resource('carousel/');
    }

    clientelist() {
        return this._resource
            .query()
            .then( res =>  {
                return res.json();
            }, err => {
                throw new Error('Não foi possível obter a lista de clientes.');
            });
    }

    Testimonials() {
        return this.testimonialResource
            .query()
            .then( res =>  {
                return res.json();
            }, err => {
                throw new Error('Não foi possível obter a lista de depoimentos.');
            });
    }


    Clippinglist() {
        return this.clippingResource
            .query()
            .then( res =>  {
                return res.json();
            }, err => {
                throw new Error('Não foi possível obter a lista de clippings.');
            });
    }

    Carousel() {
        return this.carouselResource
            .query()
            .then( res =>  {
                return res.json();
            }, err => {
                throw new Error('Não foi possível obter a lista de carousel.');
            });
    }
    blocks() {
        return this.about
            .query()
            .then( res =>  {
                return res.json();
            }, err => {
                throw new Error('Não foi possível obter a lista de publicacoes.');
            });
    }
}



// WEBPACK FOOTER //
// ./src/domain/HomeService.js